import request from "./../utils/request";

export function getAllWebHooks() {
    return request({
        url: `/webhook`,
        method: "get",
    });
}

export function addWebhook(data) {
    return request({
        url: "/webhook",
        method: "post",
        data: data,
    });
}

export function updateWebHook({ id, payload }) {
    return request.put(`/webhook/update/${id}`, { query: payload });
}

export function deleteWebhook(id) {
    return request.delete(`/webhook/id/${id}/delete`);
}
